import { render, staticRenderFns } from "./AuthRegisterButton.vue?vue&type=template&id=524a6a88"
import script from "./AuthRegisterButton.vue?vue&type=script&lang=ts"
export * from "./AuthRegisterButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports